import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface UserStoreState {
  userId: string | null; // userId의 타입 (null 또는 string)
  setUserId: (id: string) => void; // userId를 설정하는 함수
  clearUserId: () => void; // userId를 초기화하는 함수
}

/**
 * userId를 저장하는 스토어 - session storage 저장 (모바일 본인 인증을 위한 처리)
 */
export const useUserIdStore = create<UserStoreState>()(
  devtools(
    persist(
      (set) => ({
        userId: null, // 초기값 설정 (null 또는 다른 값)
        setUserId: (id: string) => set(() => ({ userId: id }), false, `setUserId(${id})`), // userId를 설정하는 함수
        clearUserId: () => set(() => ({ userId: null }), false, 'clearUserId'), // userId를 초기화하는 함수
      }),
      {
        name: 'userid-storage',
        storage: createJSONStorage(() => sessionStorage),
      }
    ),
    { name: 'UserIdStore' }
  )
);

// 컴포넌트 외부에서 상태를 변경할 수 있도록 하는 함수
export const setUserIdState = (id: string) => {
  const idState = useUserIdStore.getState();
  if (!idState.userId) {
    useUserIdStore.getState().setUserId(id);
  }
};

export const clearUserIdState = () => {
  useUserIdStore.getState().clearUserId();
};
